var React = require('react');

function IconMbzero (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m14 3.491-1.376-1.34-1.206 1.175C10.528 2.46 9.344 2 8 2 5.06 2 2.9 4.171 2.9 8c0 1.186.207 2.214.581 3.066L2 12.51l1.376 1.341 1.204-1.174C5.466 13.542 6.65 14 8 14c2.924 0 5.1-2.171 5.1-6 0-1.185-.208-2.211-.583-3.063L14 3.49zm-8.329 4.51c0-2.636.952-3.73 2.329-3.73.655 0 1.213.254 1.618.81L5.713 8.89a9.003 9.003 0 0 1-.042-.888zm4.641 0c0 2.635-.952 3.73-2.312 3.73-.66 0-1.22-.252-1.627-.803l3.899-3.801c.026.27.04.56.04.874z","fill":"#2B2F35"}));
}

IconMbzero.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = IconMbzero;

IconMbzero.default = IconMbzero;
